const PRIVATE_EXPORT_KEY_PREFIX = 'user-data-exports/';

export function isPrivateExportStorageKey(value: string | null | undefined): value is string {
  return (
    typeof value === 'string' &&
    value.startsWith(PRIVATE_EXPORT_KEY_PREFIX) &&
    !value.includes('?') &&
    !value.includes('#') &&
    !value.includes('://') &&
    !value.startsWith('data:')
  );
}

export function resolvePrivateExportStorageKey(record: {
  storageKey?: string | null;
  downloadUrl?: string | null;
}): string | null {
  if (isPrivateExportStorageKey(record.storageKey)) return record.storageKey;
  if (isPrivateExportStorageKey(record.downloadUrl)) return record.downloadUrl;
  return null;
}

export function privateExportPointerWrite(storageKey: string | null) {
  if (storageKey !== null && !isPrivateExportStorageKey(storageKey)) {
    throw new Error('Invalid private export storage key');
  }
  return { storageKey, downloadUrl: storageKey };
}
